<template>
  <div>
    <el-table :data="reason_list" height="70vh"
              border
              style="width: 100%">
      <el-table-column
        prop="a_house_name"
        label="房产信息" width="360" fixed></el-table-column>
      <el-table-column
        prop="name"
        label="业主"
        width="150">
      </el-table-column>
      <el-table-column
        prop="arrears_type"
        label="欠费类型"
        width="120">
      </el-table-column>
      <el-table-column
        prop="user_appeal"
        label="欠费原因"
        width="120">
      </el-table-column>
      <el-table-column
        prop="arrears_type"
        label="业主诉求"
        width="280">
      </el-table-column>
      <el-table-column
        prop="measures"
        label="催缴措施"
        width="280">
      </el-table-column>
      <el-table-column
        prop="ymd"
        label="预计回款时间"
        width="120">
      </el-table-column>
      <el-table-column
        prop="user_person_liable"
        label="催缴责任人"
        width="150">
      </el-table-column>
      <el-table-column
        prop="created_at"
        label="更新时间"
        width="150" fixed="right">
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
import ButlerHttp from "../Butler/common/ButlerHttp";

export default {
  name: "reason-list",
  props: {
    id: {
      type: String|Number,
      required: true,
      default: 0
    },
  },
  data(){
    return{
      reason_list:[]
    }
  },
  mounted() {
    this.getReasonList();
  },
  methods:{
    getReasonList(){
      const that = this;
      this.loading = true;
      ButlerHttp.post("ButlerCustomer/getReasonList",{
        customer_id:this.id
      },(res) => {
        if(res.code){
          that.reason_list = res.data;
        }else {
          that.$message.error(res.msg);
        }
      })
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Admin/Customer/reason-list.vue